import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Table from '../../Table';
import Pagination from '../../TablePagination';
import UserkeyIssue from './UserkeyIssue';
import UserkeyDelete from './UserkeyDelete';
import { SMSSend } from '../../SMSSend';
import { dateFormatter, pincodeTypeFormatter } from '../../../lib/formatter';

const UserkeyList = ({
  bookingId,
  roomName,
  userkeyListItems,
  reload,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenKeyIssueModal, setIsOpenKeyIssueModal ] = useState(false);
  const [ isOpenKeyDeleteModal, setIsOpenKeyDeleteModal ] = useState(false);
  const [ isOpenSMSSendModal, setIsOpenSMSSendModal ] = useState(false);
  const [ paginationItem, setPaginationItem ] = useState({
    offset: 0,
    limit: 10,
  });
  const [ selectedKeyId, setSelectedKeyId ] = useState(null);
  const [ currentPageNumber, setCurrentPageNumber ] = useState(1);
  const [ SMSSendItem, setSMSSendItem ] = useState({
    type: '',
    value: '',
    keyId: '',
  });

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const selectMobilekeyDelete = (keyId, pincode) => {
    if (pincode) return;
    setSelectedKeyId(keyId);
    setIsOpenKeyDeleteModal(true);
  };

  const selectSMSSend = (pincodeId, pincode, userId, exchangekey) => {
    if (!pincode && !exchangekey) return;
    if (pincode) {
      setSMSSendItem({
        ...SMSSendItem,
        type: 'pincode',
        value: pincode,
        keyId: pincodeId,
      });
    } else {
      setSMSSendItem({
        ...SMSSendItem,
        type: 'mobilekey',
        value: exchangekey,
        keyId: userId,
      });
    }
    setIsOpenSMSSendModal(true);
  };

  return (
    <Fragment>
      <Table
        columns={[
          {
            key: 'user_name',
            text: t('data_column.key_user_name'),
            width: '18%',
            formatter: {
              func: (name, phoneNumber) => `${name}(${phoneNumber})`,
              params: ['user_name', 'phone_number'],
            },
          },
          {
            key: 'checkin_at',
            text: t('data_column.start_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              params: ['checkin_at'],
            },
          },
          {
            key: 'checkout_at',
            text: t('data_column.end_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              params: ['checkout_at'],
            },
          },
          {
            key: 'phone_number',
            text: t('data_column.key_type'),
            width: '12%',
            formatter: {
              func: (cardNo, pincode, pincodeType) => cardNo ? t('data.key_type.cardkey') : pincode ? `${t('data.key_type.pincode')}(${pincodeTypeFormatter(pincodeType)})` : t('data.key_type.mobilekey'),
              params: ['card_no', 'pincode', 'type'],
            },
          },
          {
            key: 'card_no',
            text: t('data_column.card_no'),
            width: '7%',
          },
          {
            key: 'exchangekey',
            text: t('data_column.exchangekey'),
            width: '7%',
          },
          {
            key: 'pincode',
            text: t('data_column.pincode'),
            width: '7%',
          },
          {
            key: 'seq_num',
            text: t('data_column.sequence'),
            width: '8%',
          },
          {
            key: 'created_at',
            text: t('data_column.created_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              params: ['created_at'],
            },
          },
          {
            key: 'button',
            text: '',
            width: '5%',
            items: [
              {
                text: t('button.delete'),
                disabled: {
                  func: (pincode) => pincode,
                  params: ['pincode'],
                },
                action: {
                  func: selectMobilekeyDelete,
                  params: ['user_id', 'pincode'],
                },
              },
              {
                text: t('button.sms_resend'),
                disabled: {
                  func: (pincode, exchangekey) => !pincode && !exchangekey,
                  params: ['pincode', 'exchangekey'],
                },
                action: {
                  func: selectSMSSend,
                  params: ['id', 'pincode', 'user_id', 'exchangekey'],
                },
              },
            ],
          },
        ]}
        datas={userkeyListItems}
      />
      <div className='form-item-add'>
        <button className='btn-item-add list' onClick={() => setIsOpenKeyIssueModal(true)}>
          <FontAwesomeIcon icon={faPlusCircle} className='icon-item-add'/>
          <span>{t('button.key_issue')}</span>
        </button>
      </div>
      <Pagination
        total={userkeyListItems.length}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
      <UserkeyIssue
        isOpen={isOpenKeyIssueModal}
        toggle={() => setIsOpenKeyIssueModal(!isOpenKeyIssueModal)}
        reload={reload}
        bookingId={bookingId}
        roomName={roomName}
      />
      <UserkeyDelete
        isOpen={isOpenKeyDeleteModal}
        toggle={() => setIsOpenKeyDeleteModal(!isOpenKeyDeleteModal)}
        reload={reload}
        bookingId={bookingId}
        keyId={selectedKeyId}
      />
      <SMSSend
        isOpen={isOpenSMSSendModal}
        isResend={true}
        toggle={() => setIsOpenSMSSendModal(!isOpenSMSSendModal)}
        smsSendItem={{...SMSSendItem, bookingId}}
        reload={() => {
          reload();
          setIsOpenSMSSendModal(!isOpenSMSSendModal);
        }}
      />
    </Fragment>
  );
};

export default UserkeyList;